module.exports = __webpack_public_path__ + "img/kora-winter-photo-min.dca42e56.jpg";